var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRandom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20508 2.38477C9.52951 2.38416 9.81756 2.59221 9.91895 2.90039L15.0312 18.4502L17.1572 11.8926L17.2031 11.7822C17.3298 11.5348 17.5856 11.3741 17.8701 11.374H22C22.4142 11.374 22.7499 11.7099 22.75 12.124C22.75 12.5382 22.4142 12.874 22 12.874H18.416L15.75 21.0977C15.6499 21.4064 15.3626 21.6165 15.0381 21.6172C14.7137 21.6179 14.4257 21.4096 14.3242 21.1016L9.21094 5.55078L7.00488 12.3555C6.90465 12.6645 6.61687 12.8738 6.29199 12.874H2C1.58579 12.874 1.25 12.5382 1.25 12.124C1.25005 11.7099 1.58582 11.374 2 11.374H5.74609L8.49316 2.90332L8.53906 2.79297C8.66548 2.5459 8.92099 2.38535 9.20508 2.38477Z",
    fill: "#1C242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom);
export default __webpack_public_path__ + "static/media/random.f1b69581d9c4e41482e12d44e2afdc58.svg";
export { ForwardRef as ReactComponent };